import { Name as EntityName } from '../../entity';

export const TYPE = `${EntityName.ACTION_PREFIX}FORM:send_form_success`;
